import React from 'react';
import styled from 'styled-components';

import { Checkbox } from '@material-ui/core';

import IconCheckbox from '../../assets/form-checkbox.svg';
import IconCheckboxChecked from '../../assets/form-checkbox-checked.svg';

const Root = styled.span`
	display: inline-block;
	vertical-align: middle;

	.MuiCheckbox-root {
		padding: 0;
		margin-right: 10px;

		img {
			max-width: 20px;
			width: 100%;
			height: auto;
		}
	}
`;

const CheckboxPrimary = ({ name = 'cheked01', ...props }) => (
	<Root>
		<Checkbox
			icon={<img src={IconCheckbox} alt="Checkbox" />}
			checkedIcon={<img src={IconCheckboxChecked} alt="Checkbox checked" />}
			name={name}
			{...props}
		/>
	</Root>
);

export default CheckboxPrimary;
